import React, { useState, useEffect } from 'react';
import { supabase } from '../../../../lib/supabase';
import EOIResponseFormModal from '../../../../components/EOIResponses/EOIResponseFormModal';
import type { EOIResponse } from '../../../../types/eoi-response';
import { useNavigate } from 'react-router-dom';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  eoiResponse: EOIResponse;
}

export default function EditEOIResponseModal({ isOpen, onClose, onSuccess, eoiResponse }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  
  // Log whenever the modal is opened with EOI response data
  useEffect(() => {
    if (isOpen && eoiResponse) {
      console.log('EditEOIResponseModal opened with data:', eoiResponse);
    }
  }, [isOpen, eoiResponse]);

  const handleSubmit = async (data: Omit<EOIResponse, 'reoi_id'>) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const { error } = await supabase
        .from('eoi_responses')
        .update(data)
        .eq('reoi_id', eoiResponse.reoi_id);

      if (error) throw error;

      onSuccess();
      onClose();
      navigate('/admin/eoi-responses', { replace: true });
    } catch (err: any) {
      setError(err.message || 'An error occurred while updating the EOI response');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <EOIResponseFormModal
      isOpen={isOpen}
      onClose={onClose}
      initialData={eoiResponse}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      error={error}
      title="Edit EOI Response"
      submitLabel="Save Changes"
      isEditMode={true}
    />
  );
}
